import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, Typography, useTheme } from '@mui/material'
import type { FormattedAgentActivity } from '../utils'

interface ActivityContextProps {
  readonly activity: FormattedAgentActivity
}

export const ActivityContext: FC<ActivityContextProps> = ({ activity }) => {
  const theme = useTheme()

  const contextColor =
    theme.palette.mode === 'dark' ? theme.palette.error.light : theme.palette.error.main

  if (activity.toolName.startsWith('MCP Server')) {
    const toolNamePart = activity.toolName
    const actionPart = activity.activityContext.replace(toolNamePart, '').trim()

    return (
      <Box component="span" sx={mcpContainerSx}>
        <Typography component="span" sx={mcpToolNameSx}>
          {toolNamePart}
        </Typography>
        {actionPart && (
          <Typography component="span" sx={contextSx(contextColor)}>
            {actionPart}
          </Typography>
        )}
      </Box>
    )
  }

  return (
    <Typography component="span" sx={contextSx(contextColor)}>
      {activity.activityContext}
    </Typography>
  )
}

const contextSx = (color: string): SxProps<Theme> => ({
  fontSize: '0.75rem',
  color,
  fontWeight: 500,
  fontStyle: 'italic',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

const mcpContainerSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.75,
  overflow: 'hidden',
}

const mcpToolNameSx: SxProps<Theme> = {
  fontSize: '0.75rem',
  color: 'text.primary',
  fontStyle: 'italic',
  flexShrink: 0,
}
